import type { FC, ReactNode } from 'react';
import cn from 'classnames';

import styles from './Row.module.scss';

interface IRow {
  id?: string;
  title?: ReactNode;
  margin?: 'medium' | 'none';
  align?: 'center' | 'end' | 'baseline';
  justify?: 'start' | 'end' | 'space-between';
  isListItem?: boolean;
  notWrap?: boolean;
  notSpace?: boolean;
  border?: 'bottom';
  titleSize?: 'small';
}

export const Row: FC<IRow> = ({
  children,
  margin,
  id,
  title,
  isListItem,
  notWrap,
  notSpace,
  border,
  titleSize,
  align,
  justify,
}) => {
  const labelAttributes = {
    ...(titleSize === 'small' && { 'data-small': true }),
  };

  const rowAttributes = {
    ...(margin === 'medium' && { 'data-medium': true }),
    ...(margin === 'none' && { 'data-unset': true }),
    ...(isListItem && { 'data-list-item': true }),
    ...(notWrap && { 'data-no-wrap': true }),
    ...(notSpace && { 'data-no-space': true }),
    ...(border === 'bottom' && { 'data-border-bottom': true }),
    ...(align === 'end' && { 'data-align-end': true }),
    ...(align === 'baseline' && { 'data-align-baseline': true }),
    ...(justify === 'start' && { 'data-justify-start': true }),
    ...(justify === 'end' && { 'data-justify-end': true }),
  };

  return (
    <>
      {title && (
        <div className={cn('shared-group-margin', styles.TitleRow)}>
          <label className={cn('shared-group-label', styles.Title)} {...labelAttributes}>
            {title}
          </label>
        </div>
      )}
      <div id={id} className={styles.Row} {...rowAttributes} data-align={align}>
        {children}
      </div>
    </>
  );
};
